export type EmissionFactorDefaultOptions = string;

export enum EmissionFactorByFactorErrorType {
  FACTOR_ERROR_TYPE_1 = 'FACTOR_ERROR_TYPE_1',
  FACTOR_ERROR_TYPE_2 = 'FACTOR_ERROR_TYPE_2',
  FACTOR_ERROR_TYPE_3 = 'FACTOR_ERROR_TYPE_3',
  FACTOR_ERROR_TYPE_4 = 'FACTOR_ERROR_TYPE_4',
  FACTOR_ERROR_TYPE_5 = 'FACTOR_ERROR_TYPE_5',
  FACTOR_ERROR_TYPE_6 = 'FACTOR_ERROR_TYPE_6',
}

export enum EmissionSourceCategory {
  CAT_1 = '1',
  CAT_2 = '2',
  CAT_3 = '3',
  CAT_4 = '4',
  CAT_5 = '5',
  CAT_6 = '6',
}

export enum EmissionSourceSubCategory {
  CAT_1_1 = '1.1',
  CAT_1_2 = '1.2',
  CAT_1_3 = '1.3',
  CAT_1_4 = '1.4',
  // Should not show in system
  // CAT_1_5 = '1.5',
  // CAT_1_BIOMASS = '1.biomassEmissions',

  CAT_2_1 = '2.1',
  CAT_2_2 = '2.2',

  CAT_3_1 = '3.1',
  CAT_3_2 = '3.2',
  CAT_3_3 = '3.3',
  CAT_3_4 = '3.4',
  CAT_3_5 = '3.5',

  CAT_4_1A = '4.1a',
  CAT_4_1B = '4.1b',
  CAT_4_2 = '4.2',
  CAT_4_3 = '4.3',
  CAT_4_4 = '4.4',
  CAT_4_5 = '4.5',

  CAT_5_1 = '5.1',
  CAT_5_2 = '5.2',
  CAT_5_3 = '5.3',
  CAT_5_4 = '5.4',
  CAT_5_5 = '5.5',
  CAT_5_6 = '5.6',

  CAT_6_1 = '6.1',
}

export enum EmissionSourceTypeCat3_5 {
  ACCOMMODATION = 'ACCOMMODATION',
  TRANSPORTATION = 'TRANSPORTATION',
}

export const EmissionSourceSubType = {
  ...EmissionSourceTypeCat3_5,
};

export type EmissionSourceSubType = EmissionSourceTypeCat3_5;

export enum EmissionSourceRawMaterialOrProduct {
  RAW_MATERIAL = 'RAW_MATERIAL',
  PRODUCT = 'PRODUCT',
  NA = 'NA',
}

export type EmissionSourceRawMaterial1 = string;
export type EmissionSourceRawMaterial2 = string;
export enum EmissionSourceGreenHouseGases {
  NA = 'NA',
  CO2 = 'CO2',
  CH4 = 'CH4',
  N2O = 'N2O',
  HFCS = 'HFCS',
  PFCS = 'PFCS',
  SF6 = 'SF6',
  NF3 = 'NF3',
}

export enum EmissionSourceMeasurementMethod {
  EMISSION_FACTORS_APPROACH = 'EMISSION_FACTORS_APPROACH',
  MASS_BALANCE_APPROACH = 'MASS_BALANCE_APPROACH',
  DIRECT_MONITOR_APPROACH = 'DIRECT_MONITOR_APPROACH',
}

export enum EmissionSourceFactorType {
  RECOMMEND = 'RECOMMEND',
  DEFAULT = 'DEFAULT',
  CUSTOMIZED = 'CUSTOMIZED',
  SELF = 'FACTORY_SPECIFIC', // for self manufactured finished/WIP products
}

export enum EmissionSourceFactorSource {
  DEFAULT = 'DEFAULT',
  TRANSPORTATION = 'TRANSPORTATION',
  TREATMENT = 'TREATMENT',
  TDLOSS = 'TDLOSS',
}

export enum EmissionSourceFactorUnitType {
  LINEAR = 'LINEAR',
  SQUARE = 'SQUARE',
  CUBIC = 'CUBIC',
  WEIGHT = 'WEIGHT',
  ENERGY_KWH = 'ENERGY_KWH',
  ENERGY_J = 'ENERGY_J',
  CURRENCY = 'CURRENCY',
  POWER = 'POWER',
  OTHER = 'OTHER',
}

export enum OcrCategory {
  OIL_BILL = 'oil',
  ELECTRIC_BILL = 'electricity',
  WATER_BILL = 'water',
}

export enum DataActivityStatus {
  CREATED = 'CREATED',
  SUBMITTED = 'SUBMITTED',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  DELETED = 'DELETED',
  RESUBMITTED = 'RESUBMITTED',
  PROCESSING = 'PROCESSING',
}

export enum FormSteps {
  StepOneBasicInformation = 0,
  StepTwoEmissionFactors = 1,
  StepThreeAssignUsers = 2,
}

export enum EmissionStatus {
  OK = 'ok',
  LOCK = 'lock',
}

export enum FormMode {
  VIEW = 'view',
  EDIT = 'edit',
  CREATE = 'create',
}

export enum RawMaterialOrProduct4_1b {
  RM_PROD_4_1B_1 = 'RM_PROD_4_1B_1',
  RM_PROD_4_1B_2 = 'RM_PROD_4_1B_2',
  RM_PROD_4_1B_3 = 'RM_PROD_4_1B_3',
  RM_PROD_4_1B_4 = 'RM_PROD_4_1B_4',
  RM_PROD_4_1B_5 = 'RM_PROD_4_1B_5',
  RM_PROD_4_1B_6 = 'RM_PROD_4_1B_6',
  RM_PROD_4_1B_OTHER = 'RM_PROD_4_1B_OTHER',
}

export enum EmissionSourceRelevance {
  REL_NULL = 'REL_NULL',
  REL_FALSE = 'REL_FALSE',
  REL_TRUE = 'REL_TRUE',
}
